export default __webpack_public_path__ + "static/media/shrewdblow6.bed0093c.png";